import { AwsRum, AwsRumConfig } from "aws-rum-web"
import { isIgnoredRumError } from "helpers/rumErrorFilter"

let rumClient: AwsRum | undefined

export const AwsRumClient = (
  rumAppMonitorId: string,
  rumIdentityPool: string,
  awsRegion: string
): AwsRum | undefined => {
  if (rumClient) {
    return rumClient
  }

  const config: AwsRumConfig = {
    sessionSampleRate: 1,
    identityPoolId: rumIdentityPool,
    endpoint: `https://dataplane.rum.${awsRegion}.amazonaws.com`,
    telemetries: [["errors", { ignore: isIgnoredRumError }]],
    allowCookies: true,
    cookieAttributes: {
      unique: true,
    },
    enableXRay: false
  }

  const APPLICATION_ID = rumAppMonitorId
  const APPLICATION_VERSION = "1.0.0"
  const APPLICATION_REGION = awsRegion

  try {
    rumClient = new AwsRum(APPLICATION_ID, APPLICATION_VERSION, APPLICATION_REGION, config)
  } catch (error) {
    console.error("Failed to initialize AWS RUM client:", error)
    return undefined
  }

  return rumClient
}
